export default [
  ["denim", /*            */ "ui/denim.png"],
  ["parchment", /*        */ "ui/parchment.jpg"],
  ["banner-bg", /*        */ "systems/pf2e/assets/sheet/banner-bg.png"],
  ["banner-bg2", /*       */ "systems/pf2e/assets/sheet/banner-bg2.png"],
  ["stroke", /*           */ "systems/pf2e/assets/sheet/stroke.svg"],
  ["stroke2", /*          */ "systems/pf2e/assets/sheet/stroke2.svg"],
  ["stroke3", /*          */ "systems/pf2e/assets/sheet/stroke3.svg"],
  ["platinum-pieces", /*  */ "systems/pf2e/icons/equipment/treasure/currency/platinum-pieces.jpg"],
  ["gold-pieces", /*      */ "systems/pf2e/icons/equipment/treasure/currency/gold-pieces.jpg"],
  ["silver-pieces", /*    */ "systems/pf2e/icons/equipment/treasure/currency/silver-pieces.jpg"],
  ["copper-pieces", /*    */ "systems/pf2e/icons/equipment/treasure/currency/copper-pieces.jpg"],
  ["d20-black", /*        */ "icons/svg/d20-black.svg"],
  ["d20-grey", /*         */ "icons/svg/d20-grey.svg"],
  ["shield-blue", /*      */ "systems/pf2e/assets/sheet/shield-blue.png"],
  ["shield-red", /*       */ "systems/pf2e/assets/sheet/shield-red.png"],
  ["red-sidebar", /*      */ "systems/pf2e/assets/sheet/red_sidebar.png"],
  ["pathfinder-orn", /*   */ "systems/pf2e/assets/icons/pathfinder-orn.svg"],
  ["level-badge", /*      */ "systems/pf2e/assets/sheet/level-badge.png"],
  ["header", /*           */ "systems/pf2e/assets/sheet/header.png"],
  ["sheet-bg", /*         */ "systems/pf2e/assets/sheet-bg.jpg"],
  ["border-pattern", /*   */ "systems/pf2e/assets/sheet/border-pattern.png"],
  ["nav-item-inactive", /**/ "systems/pf2e/assets/sheet/nav-item-inactive.png"],
  ["nav-item", /*         */ "systems/pf2e/assets/sheet/nav-item.png"],
  ["corner-box", /*       */ "systems/pf2e/assets/sheet/corner-box.png"],
  ["gold", /*             */ "systems/pf2e/assets/sheet/gold.jpg"],
  ["chevron-down", /*     */ "systems/pf2e/assets/icons/chevron-down.svg"],
];
